module.exports = __webpack_public_path__ + "media/images/strategic-partners/new/Bonita-bdc87f981aa3464633b1bd79aa69825a.png";